import styled from 'styled-components'

import { Scroll } from 'styles/Helpers'

export const BasicInfoStepWrapper = styled.div`
  form > button {
    margin: ${({ theme }) => theme.spacings[2]} auto;
  }

  form > button + button {
    margin-top: ${({ theme }) => theme.spacings[2]};
  }

  .container-form {
    max-width: 800px;
    margin: 0 auto;
  }
`

export const Field = styled.div`
  width: 100%;

  padding: ${({ theme }) => `${theme.spacings[2.5]} ${theme.spacings[4]}`};
  margin-bottom: ${({ theme }) => theme.spacings[8]};

  /* color: ${({ theme }) => theme.colors.pinkishGrey}; */
  color: ${({ theme }) => theme.colors.greyishBrownFour};

  border: 1px solid ${({ theme }) => theme.colors.paleGrey};
  border-radius: 10px;
  height: 43px;

  background-color: ${({ theme }) => theme.colors.paleGreyThree};
`

export const TextEditorField = styled.div`
  width: 100%;

  min-height: 80px;
  max-height: 500px;

  ${Scroll};

  padding: ${({ theme }) => `${theme.spacings[2.5]} ${theme.spacings[4]}`};
  margin-bottom: ${({ theme }) => theme.spacings[8]};

  /* color: ${({ theme }) => theme.colors.pinkishGrey}; */
  color: ${({ theme }) => theme.colors.greyishBrownFour};

  border: 1px solid ${({ theme }) => theme.colors.paleGrey};
  border-radius: 10px;

  background-color: ${({ theme }) => theme.colors.paleGreyThree};
`
